module.exports = __webpack_public_path__ + "static/dummy_teaser-baf1ffd28bf0a87c36a7fb8d7eda2f4c.jpg";